<div>
<div class="card pv-dt-card border-0 d-none d-md-block" data-bs-theme="dark">
    <div class="card-body p-3 p-lg-4 position-relative">
        <div v-if="is_loading" class="bg-black bg-opacity-50 z-3 position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center gap-2 rounded-4">
            <div class="spinner-border spinner-border-sm text-warning" role="status" aria-hidden="true"></div>
            <small class="text-body-secondary">Loading users...</small>
        </div>

        <!-- Keyed wrapper: re-created whenever the user list changes, so Vue never patches rows DataTables has moved -->
        <div class="pv-dt-host" :key="data_table_version">
            <table
                ref="data_table"
                class="table table-hover align-middle mb-0 w-100 global_data_table pv-dt-table"
                data-search-placeholder="Search users..."
                data-non-orderable-targets="[5]"
                data-page-length="10"
                data-order-column="0"
                data-order-direction="asc"
                data-responsive="false"
            >
                <thead>
                    <tr>
                        <th scope="col" class="small text-uppercase text-body-secondary fw-bold">User</th>
                        <th scope="col" class="small text-uppercase text-body-secondary fw-bold">Role</th>
                        <th scope="col" class="small text-uppercase text-body-secondary fw-bold">Status</th>
                        <th scope="col" class="small text-uppercase text-body-secondary fw-bold">Session</th>
                        <th scope="col" class="small text-uppercase text-body-secondary fw-bold">Last Login</th>
                        <th scope="col" class="small text-uppercase text-body-secondary fw-bold text-end">Actions</th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="user in users" :key="get_user_loading_key(user)">
                        <td :data-order="get_full_name(user)">
                            <div class="d-flex align-items-center gap-3">
                                <span class="settings-user-avatar d-inline-flex align-items-center justify-content-center rounded-circle">
                                    {{ get_initials(user) }}
                                </span>
                                <div class="d-flex flex-column min-w-0">
                                    <span class="text-white fw-semibold">
                                        {{ get_full_name(user) }}
                                        <span v-if="is_current_user(user)" class="badge rounded-pill text-bg-secondary fw-medium ms-1">You</span>
                                    </span>
                                    <small class="text-body-secondary text-truncate">{{ user.email || "-" }}</small>
                                </div>
                            </div>
                        </td>

                        <td>
                            <span class="badge rounded-pill bg-info-subtle text-info-emphasis border border-info-subtle text-capitalize px-3 py-2">{{ user.role || "-" }}</span>
                        </td>

                        <td>
                            <span
                                class="badge rounded-pill border px-3 py-2"
                                :class="user.is_active
                                    ? 'bg-success-subtle text-success-emphasis border-success-subtle'
                                    : 'bg-secondary-subtle text-secondary-emphasis border-secondary-subtle'"
                            >
                                <span class="d-inline-block rounded-circle p-1 me-1 align-middle" :class="user.is_active ? 'text-bg-success' : 'text-bg-secondary'"></span>{{ user.is_active ? "Active" : "Inactive" }}
                            </span>
                        </td>

                        <td>
                            <span class="text-body-secondary">{{ user.session_policy === "custom" ? `${user.session_timeout_minutes || "-"} min` : user.session_policy === "unlimited" ? "Unlimited" : "Default" }}</span>
                        </td>

                        <td :data-order="get_last_login_time(user)">
                            <span :class="user.last_login ? 'text-white' : 'text-body-tertiary'">{{ get_last_login_label(user) }}</span>
                        </td>

                        <td class="text-end">
                            <div class="d-inline-flex gap-2">
                                <button
                                    type="button"
                                    class="btn btn-outline-light btn-sm rounded-3 text-xs d-inline-flex align-items-center justify-content-center gap-1"
                                    @click="open_edit_user(user)"
                                    aria-label="Edit user"
                                >
                                    <i class="bi bi-pencil-square"></i><span>Edit</span>
                                </button>

                                <span class="d-inline-block" :title="get_status_action_title(user)">
                                    <button
                                        type="button"
                                        class="btn btn-sm rounded-3 text-xs d-inline-flex align-items-center justify-content-center gap-1"
                                        :class="user.is_active ? 'btn-outline-warning' : 'btn-outline-success'"
                                        @click="toggle_user_status(user)"
                                        :disabled="is_status_action_disabled(user)"
                                        :aria-label="user.is_active ? 'Deactivate user' : 'Activate user'"
                                    >
                                        <span v-if="is_user_status_updating(user)" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        <i v-else class="bi" :class="user.is_active ? 'bi-person-slash' : 'bi-person-check'"></i>
                                        <span>{{ user.is_active ? "Deactivate" : "Activate" }}</span>
                                    </button>
                                </span>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<div class="d-md-none">
    <div v-if="is_loading" class="glass-card text-white border border-white border-opacity-10 rounded-4">
        <div class="card-body d-flex align-items-center gap-3 text-white-50 p-3">
            <div class="spinner-border spinner-border-sm text-light" role="status" aria-hidden="true"></div>
            <span class="text-xs">Loading users...</span>
        </div>
    </div>

    <div v-else-if="!users.length" class="glass-card text-white border border-white border-opacity-10 rounded-4">
        <div class="card-body text-center py-5">
            <span class="d-inline-flex align-items-center justify-content-center rounded-circle border border-white border-opacity-10 bg-white bg-opacity-10 text-white mb-3" style="width: 2.5rem; height: 2.5rem;">
                <i class="bi bi-people-fill"></i>
            </span>
            <p class="text-white fw-semibold mb-1">No users available</p>
            <p class="text-white-50 text-xs mb-0">Added users will appear here.</p>
        </div>
    </div>

    <div v-else class="d-flex flex-column gap-3">
        <SettingsMobileListControls
            :search-value="mobile_search"
            search-placeholder="Search users"
            :current-page="mobile_page"
            :page-count="mobile_page_count"
            pagination-label="User pages"
            :show-pagination="false"
            @update:search-value="mobile_search = $event"
            @update:current-page="set_mobile_page"
        />

        <article
            v-for="user in paginated_mobile_users"
            :key="`mobile-user-${user.id || user.email}`"
            class="glass-card text-white border border-white border-opacity-10 rounded-4"
        >
            <div class="card-body p-3">
                <div class="d-flex align-items-start justify-content-between gap-3 mb-3">
                    <div class="d-flex align-items-center gap-3 min-w-0">
                        <span class="settings-user-avatar d-inline-flex align-items-center justify-content-center rounded-circle flex-shrink-0">
                            {{ get_initials(user) }}
                        </span>
                        <div class="min-w-0">
                            <p class="text-uppercase text-primary fw-bold text-xs mb-1">Member</p>
                            <h6 class="fw-semibold mb-1 text-break">{{ get_full_name(user) }}</h6>
                            <p class="text-white-50 text-xs mb-0 text-break">{{ user.email || "-" }}</p>
                        </div>
                    </div>

                    <span
                        class="badge rounded-pill text-xs flex-shrink-0"
                        :class="user.is_active ? 'text-bg-success' : 'text-bg-secondary'"
                    >
                        {{ user.is_active ? "Active" : "Inactive" }}
                    </span>
                </div>

                <div class="row g-3">
                    <div class="col-12">
                        <p class="text-uppercase text-primary fw-bold text-xs mb-1">Role</p>
                        <span class="badge rounded-pill text-bg-info bg-opacity-25 border border-info border-opacity-25 small text-white">
                            {{ user.role || "-" }}
                        </span>
                    </div>

                    <div class="col-12">
                        <p class="text-uppercase text-primary fw-bold text-xs mb-1">Last Login</p>
                        <p class="fw-semibold text-xs mb-0">{{ get_last_login_label(user) }}</p>
                    </div>

                    <div class="col-12">
                        <p class="text-uppercase text-primary fw-bold text-xs mb-2">Actions</p>
                        <div class="d-flex flex-wrap gap-2">
                            <button
                                type="button"
                                class="btn btn-outline-light btn-sm rounded-3 text-xs d-inline-flex align-items-center justify-content-center gap-1"
                                @click="open_edit_user(user)"
                                aria-label="Edit user"
                            >
                                <i class="bi bi-pencil-square"></i>
                                <span class="text-xs">Edit</span>
                            </button>

                            <button
                                type="button"
                                :class="['btn btn-sm rounded-3 text-xs d-inline-flex align-items-center justify-content-center gap-1', user.is_active ? 'btn-warning' : 'btn-success']"
                                @click="toggle_user_status(user)"
                                :disabled="is_busy || (is_current_user(user) && user.is_active) || (!user.is_active && !has_users_endpoint)"
                                :aria-label="user.is_active ? 'Deactivate user' : 'Activate user'"
                                :title="get_status_action_title(user)"
                            >
                                <span v-if="is_user_status_updating(user)" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                <span class="text-xs">{{ user.is_active ? "Deactivate" : "Activate" }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </article>

        <div v-if="!paginated_mobile_users.length" class="glass-card text-white border border-white border-opacity-10 rounded-4">
            <div class="card-body text-center py-4">
                <p class="text-white-50 text-xs mb-0">No matching users found.</p>
            </div>
        </div>

        <SettingsMobileListControls
            :search-value="mobile_search"
            :current-page="mobile_page"
            :page-count="mobile_page_count"
            pagination-label="User pages"
            :show-search="false"
            @update:current-page="set_mobile_page"
        />
    </div>
</div>
</div>
